module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom__title"
  }, [_vm._v(_vm._s(_vm.dico.generic_content.navigation_title))]), _c('div', {
    staticClass: "bottom__navigations"
  }, [_c('router-link', {
    staticClass: "bottom__col bottom__col--left",
    attrs: {
      "to": _vm.previous.id
    }
  }, [_c('span', {
    staticClass: "bottom__nav bottom__nav--left",
    style: ({
      backgroundImage: 'url(' + _vm.getFarmPortrait(_vm.previous.infos.portrait_image) + ')'
    })
  }), _c('div', {
    staticClass: "bottom__wrapper"
  }, [_c('div', {
    staticClass: "bottom__col__title"
  }, [_vm._v(_vm._s(_vm.previous.infos.farmer_name))]), _c('div', {
    staticClass: "bottom__col__subtitle"
  }, [_vm._v(_vm._s(_vm.previous.location.label))])])]), _c('router-link', {
    staticClass: "bottom__col",
    attrs: {
      "to": _vm.next.id
    }
  }, [_c('div', {
    staticClass: "bottom__wrapper"
  }, [_c('div', {
    staticClass: "bottom__col__title"
  }, [_vm._v(_vm._s(_vm.next.infos.farmer_name))]), _c('div', {
    staticClass: "bottom__col__subtitle"
  }, [_vm._v(_vm._s(_vm.next.location.label))])]), _c('span', {
    staticClass: "bottom__nav bottom__nav--right",
    style: ({
      backgroundImage: 'url(' + _vm.getFarmPortrait(_vm.next.infos.portrait_image) + ')'
    }),
    attrs: {
      "to": _vm.next.id
    }
  })])], 1), _c('div', {
    staticClass: "bottom__legals"
  }, [_c('div', {
    staticClass: "bottom__legal"
  }, [_vm._v("*" + _vm._s(_vm.dico.generic_content.gc_disclaimer))]), _c('div', {
    staticClass: "bottom__legal"
  }, [_vm._v(_vm._s(_vm.dico.generic_content.kakaxi_disclaimer))]), _c('div', {
    staticClass: "bottom__legal"
  }, [_vm._v(_vm._s(_vm.dico.generic_content['ra-disclaimer']))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e0c3214", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e0c3214"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom/BottomComponent.vue
// module id = 818
// module chunks = 0